import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-startup-yearly',
  templateUrl: './startup-yearly.component.html',
  styleUrls: ['./startup-yearly.component.scss']
})
export class StartupYearlyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
